import React, {useEffect, useState} from "react"
import {Redirect, Route} from "react-router-dom"
import {useAuth} from "../contexts/AuthContext"
import {useGroup} from "../contexts/GroupContext";
import LoadingComponent from "../pages/LoadingComponent";

export default function AdminPrivateRoute({component: Component, ...rest}) {
    const {currentUser} = useAuth()
    const {role} = useGroup()
    const [isReady, setIsReady] = useState(false)

    //If all the data is set, we're ready to render
    useEffect(() => {
        if (currentUser !== null) {
            if (role !== undefined) {
                setIsReady(true)
            }
        } else {
            setIsReady(true)
        }
    }, [role, currentUser])

    console.log(currentUser)

    if (isReady) {
        return (
            <Route
                {...rest}
                render={props => {
                    return currentUser ? (role === "admin" ? <Component {...props} /> : <Redirect to="/"/> ) : <Redirect to="/login"/>
                }}
            />
        )
    } else {
        return (
            <LoadingComponent/>
        )
    }
}
